export default {
  mounted() {
    setTimeout(() => {
      this.$emit('componentLoaded');
    }, 1000);
  },
};
